/**
 * The sign-up verification session (email, session token, attempts left),
 * carried from Login to VerifyEmail in sessionStorage. Reads and writes never
 * throw: storage can be blocked, and the verify page copes with no data.
 */

import { AUTH_CONSTANTS } from '../constants/auth';
import type { VerificationSessionData } from '../types';

const KEY = AUTH_CONSTANTS.SESSION_KEYS.VERIFICATION_DATA;

export function getVerificationData(): VerificationSessionData | null {
  try {
    const item = sessionStorage.getItem(KEY);
    return item ? (JSON.parse(item) as VerificationSessionData) : null;
  } catch (error) {
    console.error('Error reading verification data from sessionStorage:', error);
    return null;
  }
}

export function setVerificationData(data: VerificationSessionData): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(data));
  } catch (error) {
    console.error('Error writing verification data to sessionStorage:', error);
  }
}

export function clearVerificationData(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch (error) {
    console.error('Error removing verification data from sessionStorage:', error);
  }
}
